module.exports = __webpack_public_path__ + "static/img/female-bg-pt.4c3c6a00.png";